import React, { useState, useEffect } from 'react';
import '../styles/sidebarStyle.css';
import { Link, useNavigate } from 'react-router-dom';
import Logo from '../assets/image/Logo.png';
import authService from '../services/loginService';

const Sidebar = ({ isOpen, toggleSidebar }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    const confirmLogout = window.confirm('¿Está seguro que desea cerrar sesión?');

    if (confirmLogout) {
      authService.logout();
      navigate('/');
    }
  };

  const currentUser = authService.getCurrentUser();

  // Cerrar sidebar en móvil cuando se hace clic en un enlace
  const handleLinkClick = () => {
    if (window.innerWidth <= 768) {
      toggleSidebar();
    }
  };

  // Manejar clic en opciones bloqueadas
  const handleBlockedClick = (e, sectionName) => {
    e.preventDefault();
    alert(`⚠️ Acceso restringido: No tienes permisos para acceder a ${sectionName}`);
  };

  return (
    <>
      {/* Overlay para cerrar sidebar en móvil */}
      {isOpen && (
        <div
          className="admin-sidebar-overlay"
          onClick={toggleSidebar}
        ></div>
      )}

      <div className={`admin-sidebar ${isOpen ? 'admin-sidebar-open' : ''}`}>
        {/* Header del sidebar */}
        <div className="admin-sidebar-header">
          <div className="admin-sidebar-logo">
            <img style={{ width: '200px', height: '90px' }} src={Logo} alt="Logo" />
          </div>

          {currentUser && (
            <div className="admin-sidebar-user-info">
              <p className="admin-sidebar-user-name">
                {currentUser.name} {currentUser.lastname}
              </p>
            </div>
          )}
        </div>

        {/* Área de navegación con scroll */}
        <div className="admin-sidebar-nav-container">
          <ul className="admin-sidebar-nav-links">
            <li className="admin-sidebar-nav-item">
              <Link
                to="/dashboard/reportes"
                className="admin-sidebar-nav-link"
                onClick={handleLinkClick}
              >
                Reportes
              </Link>
            </li>
            <li className="admin-sidebar-nav-item">
              <Link
                to="/dashboard/usuarios"
                className="admin-sidebar-nav-link"
                onClick={handleLinkClick}
              >
                Gestión de usuarios
              </Link>
            </li>
            <li className="admin-sidebar-nav-item">
              <a
                href="#"
                className="admin-sidebar-nav-link admin-sidebar-nav-link-disabled"
                onClick={(e) => handleBlockedClick(e, 'Gestión de reservas')}
                style={{ opacity: 0.5, cursor: 'not-allowed' }}
              >
                Gestión de reservas
                <span style={{ marginLeft: '8px', fontSize: '12px' }}>🔒</span>
              </a>
            </li>
            <li className="admin-sidebar-nav-item">
              <Link
                to="/dashboard/parqueo"
                className="admin-sidebar-nav-link"
                onClick={handleLinkClick}
              >
                Gestión de Parqueos
              </Link>
            </li>
            <li className="admin-sidebar-nav-item">
              <a
                href="#"
                className="admin-sidebar-nav-link admin-sidebar-nav-link-disabled"
                onClick={(e) => handleBlockedClick(e, 'Gestión de subscripciones')}
                style={{ opacity: 0.5, cursor: 'not-allowed' }}
              >
                Gestión de subscripciones
                <span style={{ marginLeft: '8px', fontSize: '12px' }}>🔒</span>
              </a>
            </li>
            <li className="admin-sidebar-nav-item">
              <Link
                to="/dashboard/camaras"
                className="admin-sidebar-nav-link"
                onClick={handleLinkClick}
              >
                Cámaras
              </Link>
            </li>
            <li className="admin-sidebar-nav-item">
              <a
                href="#"
                className="admin-sidebar-nav-link admin-sidebar-nav-link-disabled"
                onClick={(e) => handleBlockedClick(e, 'Formularios')}
                style={{ opacity: 0.5, cursor: 'not-allowed' }}
              >
                Formularios
                <span style={{ marginLeft: '8px', fontSize: '12px' }}>🔒</span>
              </a>
            </li>
            <li className="admin-sidebar-nav-item">
              <a
                href="#"
                className="admin-sidebar-nav-link admin-sidebar-nav-link-disabled"
                onClick={(e) => handleBlockedClick(e, 'Chats')}
                style={{ opacity: 0.5, cursor: 'not-allowed' }}
              >
                Chats
                <span style={{ marginLeft: '8px', fontSize: '12px' }}>🔒</span>
              </a>
            </li>
          </ul>
        </div>

        {/* Footer con logout - siempre visible */}
        <div className="admin-sidebar-footer">
          <button
            className="admin-sidebar-logout-button"
            onClick={handleLogout}
          >
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M16 13v-2H7V8l-5 4 5 4v-3z" />
              <path d="M20 3h-9c-1.103 0-2 .897-2 2v4h2V5h9v14h-9v-4H9v4c0 1.103.897 2 2 2h9c1.103 0 2-.897 2-2V5c0-1.103-.897-2-2-2z" />
            </svg>
            Cerrar Sesión
          </button>
        </div>
      </div>
    </>
  );
};

export default Sidebar;